import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { InlineFieldLayout } from '../index.js';
export const GroupLayoutWrapper = styled.div `
  display: flex;
  flex-direction: column;

  ${InlineFieldLayout}:not(:last-child) {
    margin-bottom: ${globalTheme.spacing.sm};
  }
`;
export const GroupLayout = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(GroupLayoutWrapper, Object.assign({}, rest), children));
};
//# sourceMappingURL=GroupLayout.js.map